<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          `Retiring an identifier is a multiple step process. 
          First, the user will select the identifier to be retired. 
          Next, the user selects an identifier to merge to if the retired identifier data 
          should be associated with another identifier. When an identifier is retired, 
          the record is removed from the Master data and is no longer available in 
          the identifier pool.`,
          `Important: Once the retirement is confirmed and processed, it cannot be reverted, 
          and it is final. It is important to select the appropriate options during a retirement,
          including if the record should be merged into another identifier.`,
          `To retire an identifier, select the “ID to Retire” option in the Decision drop down 
          menu. Remember, the “ID to Retire” will no longer be associated with any data and 
          will not be available in the identifier pool. If the identifier to be retired should 
          be merged to another identifier, select the “ID to Merge To” option in the drop-down 
          menu for the identifier to be retained. This ID will be maintained in the system and 
          all data will be associated with this identifier.`,
          `Once the appropriate options have been selected, verify the identifier information 
          in the “Retire / Merge ID Summary” and then click the “Review” button. The application 
          will navigate to a “Review Potential Duplicates” page which lists the details of the 
          selected records. The information should be reviewed before completing the retirement 
          request.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
